module.exports = __webpack_public_path__ + "img/2.0_planning.5da71a47.jpg";